import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import MunicipalLandfillMethanePage from './MunicipalLandfillMethanePage';

export const ResearchRoutes: React.FC = () => {
  const { pathname } = useLocation();

  if (
    pathname === '/research/municipal-landfill-methane-responsibility' ||
    pathname === '/research/municipal-landfill-methane-responsibility/'
  ) {
    return <MunicipalLandfillMethanePage />;
  }

  return <Navigate to="/" replace />;
};

export default ResearchRoutes;
